import { render, staticRenderFns } from "./ExcelViewer.vue?vue&type=template&id=28c1ee6c&scoped=true"
import script from "./ExcelViewer.vue?vue&type=script&lang=js"
export * from "./ExcelViewer.vue?vue&type=script&lang=js"
import style0 from "./ExcelViewer.vue?vue&type=style&index=0&id=28c1ee6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1ee6c",
  null
  
)

export default component.exports